import { StyleSheet, css } from 'aphrodite';
import { PropTypes } from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Theme } from '../../config/theme';
import { mapDispatchToProps, mapStateToProps } from '../../utils';

import { updateAppState } from '../../actions/applicationState';
import { updateUser, updateUserRemote } from '../../actions/user';

import Button from '../../components/Button';
import CheckboxField from '../../components/CheckboxField';
import ContentContainer from '../../components/ContentContainer';
import HorizontalRule from '../../components/HorizontalRule';
import TextField from '../../components/TextField';

class SettingsAccount extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newsletter: props.user.newsletter,
      dogs_in_area: props.user.dogs_in_area,
      email_matches: props.user.email_matches,
      password: '',
      new_password: '',
      retype_new_password: '',

      errors: {
        password: false,
        new_password: false,
        retype_new_password: false,
      },
    };

    this.setValue = this.updateField.bind(this);
    this.performSave = this.performSave.bind(this);
  }

  updateField(key, value) {
    this.setState({
      [key]: value,
    });
  }

  // Validate the form
  validateForm() {
    const errors = {};

    if (this.state.new_password.length > 0 && this.state.new_password.length < 8) {
      errors.new_password = 'Password must be at least 8 characters.';
    } else if (!this.state.new_password || !this.state.new_password.length) {
      errors.new_password = 'Please enter a new password';
    } else {
      errors.new_password = null;
    }

    if (this.state.retype_new_password !== this.state.new_password) {
      errors.retype_new_password = 'Your passwords do not match';
    } else if (!this.state.retype_new_password || !this.state.retype_new_password.length) {
      errors.retype_new_password = 'Please repeat your new password.';
    } else {
      errors.retype_new_password = null;
    }
    let formErrors = false;

    Object.keys(errors).forEach(key => {
      if (errors[key] !== null) {
        formErrors = true;
      }
    });

    if (formErrors) {
      this.setState({
        errors,
        hasError: true,
      });

      return false;
    }

    this.setState({
      errors,
      hasError: false,
    });

    return true;
  }

  performSave() {
    const fields = {
      newsletter: this.state.newsletter,
      dogs_in_area: this.state.dogs_in_area,
    };

    if (this.state.password.length > 0) {
      if (this.validateForm()) {
        fields.password = this.state.password;
        fields.new_password = this.state.new_password;
      } else {
        return;
      }
    }

    this.props.dispatch(
      updateAppState({
        loading: true,
      }),
    );

    this.props.dispatch(updateUserRemote(fields, this.props.user.access_token)).then(
      response => {
        this.props.dispatch(
          updateAppState({
            loading: false,
          }),
        );

        if (response && response.id) {
          this.setState({
            password: '',
            new_password: '',
            retype_new_password: '',
          });

          this.props.dispatch(updateUser(response));
        }
      },
      err => {
        this.props.dispatch(
          updateAppState({
            loading: false,
          }),
        );

        if (err.data.error === 'wrong_password') {
          this.setState({
            errors: Object.assign({}, this.state.errors, {
              password: 'You entered the wrong password',
            }),
            hasError: false,
          });
        }
      },
    );
  }

  render() {
    return (
      <ContentContainer>
        <div className={css(styles.container)}>
          <h2 className={css(styles.h2)}>Choose the notifications you{"'"}d like to receive</h2>
          <div className={css(styles.form_checkboxes)}>
            <CheckboxField
              id="newsletter"
              name="newsletter"
              label="email updates"
              fullWidth
              handler={this.setValue}
              value={this.state.newsletter}
            />
            <CheckboxField
              id="dogs_in_area"
              name="dogs_in_area"
              label="new dog listings in my area"
              fullWidth
              handler={this.setValue}
              value={this.state.dogs_in_area}
            />
          </div>
          <HorizontalRule />
          <h2 className={css(styles.h2)}>Change Password</h2>
          <div className={css(styles.form_group)}>
            <TextField
              id="password"
              name="password"
              type="password"
              value={this.state.password}
              handler={this.setValue}
              error={this.state.errors.password}
              fullWidth
              label="Please enter your current Password"
            />
          </div>
          <div className={css(styles.form_group)}>
            <TextField
              id="new_password"
              name="new_password"
              type="password"
              value={this.state.new_password}
              handler={this.setValue}
              error={this.state.errors.new_password}
              label="New Password"
            />
            <TextField
              id="retype_new_password"
              name="retype_new_password"
              type="password"
              value={this.state.retype_new_password}
              handler={this.setValue}
              error={this.state.errors.retype_new_password}
              label="Re-type New Password"
            />
          </div>
          <div className={css(styles.button_container)}>
            <Button handler={this.performSave} title="Save changes" styles={styles.button} />
          </div>
          <HorizontalRule />
        </div>
      </ContentContainer>
    );
  }
}

SettingsAccount.propTypes = {
  dispatch: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
};

const styles = StyleSheet.create({
  container: {
    width: 800,
    margin: '0 auto',

    [Theme.mobile_query]: {
      width: 'auto',
    },
  },
  h2: {
    fontSize: 20,
    margin: '45px 5px',
  },
  form_group: {
    display: 'flex',
    flexDirection: 'row',
    margin: '20px 0',

    [Theme.mobile_query]: {
      flexDirection: 'column',
    },
  },
  form_checkboxes: {
    margin: '20px 0',
  },
  button_container: {
    display: 'flex',
    justifyContent: 'flex-end',

    [Theme.mobile_query]: {
      justifyContent: 'center',
    },
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SettingsAccount);



// WEBPACK FOOTER //
// ./src/views/SettingsAccount/index.js